import axios from 'axios'
import router from '../router'
import { Notification, MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import { getToken} from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { tansParams, blobValidate } from "@/utils/sczn";
import cache from '@/plugins/cache'
import { saveAs } from 'file-saver'
export let isRelogin = { show: false };
export let uploadFile =  `${process.env.VUE_APP_BASE_API}/common/uploadMinio`
export let uploadFileBpm =  `${process.env.VUE_APP_BASE_API}/common/uploadAndBpm`
let downloadLoadingInstance;
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 100000
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  // 是否需要防止数据重复提交
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  if(config.url.indexOf('www.fairbidd.com')>-1){
    if (getToken()) {
      config.headers['Authorization'] =  getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
  }else{
    if (getToken()) {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
  }
  config.headers['Accept-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let language = window.localStorage.getItem('locale');
  if(!(language != null && language != "" && language != undefined) ){
    language = 'zh';
  }
  config.headers['language'] = language;
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const sessionObj = cache.session.getJSON('sessionObj')
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url;                  // 请求地址
      const s_data = sessionObj.data;                // 请求数据
      const s_time = sessionObj.time;                // 请求时间
      const interval = 0;                         // 间隔时间(ms)，小于此时间视为重复提交
      if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        const message = '数据正在处理，请勿重复提交';
        console.warn(`[${s_url}]: ` + message)
        return Promise.reject(new Error(message))
      } else {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
      return res.data
    }

    // 501:修改密码,手机号不存在状态码
    if(code === 501){
      return res.data
    }else if (code === 401) {
      // Message({ message: msg, type: 'error' })
      store.commit('showUnauthorizedModal',true);

      // store.dispatch('LogOut').then(() => {
      //   location.href = '/login';
      // })
    }else if(code==404){
      Message({ message: errorCode[code], type: 'error' })
    }else if (code === 500) {
      Message({ message: msg, type: 'error' })
      return res.data
    } else if (code === 601) {
      Message({ message: msg, type: 'warning' })
      return Promise.reject('error')
    } else if (code !== 200) {
      Notification.error({ title: msg })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "系统连接异常";
    } else if (message.includes("timeout")) {
      message = "当前网络不稳定，请稍后再试";
    } else if (message.includes("Request failed with status code")) {
      message = "系统" + message.substr(message.length - 3) + "异常";
    }
    Message({ message: message, type: 'error', duration: 5 * 1000 })
    return Promise.reject(error)
  }
)
export function download(url, params, filename, config, type = 'post') {
  console.log(type)
  downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
  return service[type](url, params, {
    transformRequest: [(params) => { return tansParams(params) }],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    ...config
  }).then(async (data) => {
    const isBlob = blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      Message.error(errMsg);
    }
    downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close();
  })
}
export default service
